import "./QuotesManager.ts";
import api from "./API";

export type Quote = {
    quoteId: number;
    saidBy: string;
    quote: string;
    date: string;
    addedBy: string;
}

export type QuoteTemplate = {
    saidBy: string;
    quote: string;
}

export async function getQuotes(): Promise<any> {
    try {
        const response = await api.get("/api/unihouse/get/quotes");
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function addQuote(quote: QuoteTemplate): Promise<void> {
    try {
        await api.put("/api/unihouse/add/quote", quote);
    } catch (error) {
        console.error(error);
        throw error;
    }
}
